import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

const ProductCardCoupons = ({ coupons }) => {
	const { t } = useTranslation();
	const [currentCouponIndex, setCurrentCouponIndex] = useState(0);
	const [fade, setFade] = useState(false);

	useEffect(() => {
		if (coupons.length > 1) {
			const interval = setInterval(() => {
				setFade(true);
				setTimeout(() => {
					setCurrentCouponIndex(prevIndex => (prevIndex === coupons.length - 1 ? 0 : prevIndex + 1));
					setFade(false);
				}, 500);
			}, 3500);

			return () => clearInterval(interval);
		}
	}, [coupons]);

	const activeCoupon = useMemo(() => coupons[currentCouponIndex], [coupons, currentCouponIndex]);

	if (!activeCoupon) return null;
	return (
		<div className="product-coupons">
			<span title={activeCoupon.nm} className={`${fade ? 'fade' : ''}`}>
				Κουπόνι: {activeCoupon.cd}
			</span>
		</div>
	);
};

ProductCardCoupons.propTypes = {
	product: PropTypes.object
};
export default ProductCardCoupons;
